import React from 'react';
import PropTypes from 'prop-types';
import { useLang } from 'app/context/i18n';

import B2BSubscriptionNotification from './B2BSubscriptionNotification';
import NoSubscriptionNotification from './NoSubscriptionNotification';
import ActiveSubscriptions from './ActiveSubscriptions';

export default function SubscriptionSection({
  showB2BSubscriptionNotification,
  hasUserSubscriptions,
  hasNextExpirationSubscriptions,
  userSubscriptions
}) {
  const locale = useLang();
  const checkoutUrl = `${process.env.REACT_APP_BIGBUY_URL}${locale}/subscription/checkout?idSubscription=32`;

  if (showB2BSubscriptionNotification) {
    return <B2BSubscriptionNotification checkoutUrl={checkoutUrl} />;
  }

  if (!hasUserSubscriptions) {
    return (
      <NoSubscriptionNotification
        userSubscriptions={userSubscriptions}
        checkoutUrl={checkoutUrl}
      />
    );
  }

  return (
    <ActiveSubscriptions
      hasNextExpirationSubscriptions={hasNextExpirationSubscriptions}
      userSubscriptions={userSubscriptions}
    />
  );
}

SubscriptionSection.propTypes = {
  showB2BSubscriptionNotification: PropTypes.bool.isRequired,
  hasUserSubscriptions: PropTypes.bool.isRequired,
  hasNextExpirationSubscriptions: PropTypes.bool.isRequired,
  userSubscriptions: PropTypes.arrayOf(PropTypes.node).isRequired
};
